import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Components/Sidebar.jsx";
import Navbar from "./Components/Navbar.jsx";
import Footer from "./Components/Footer.jsx";
import ClassManagement from "./Pages/ClassManagement.jsx";
import AttendanceManagement from "./Pages/AttendanceManagement.jsx";
import Examination from "./Pages/Examination.jsx";
import FeeManagement from "./Pages/FeeManagement.jsx";
import NotificationManagement from "./Pages/NotificationManagement.jsx";
import SalaryManagement from "./Pages/SalaryManagement.jsx";
import StudentManagement from "./Pages/StudentManagement.jsx";
import SubjectManagement from "./Pages/SubjectManagement.jsx";
import TeacherManagement from "./Pages/TeacherManagement.jsx";
import TransportationManagement from "./Pages/TransportationManagement.jsx";
import UserManagement from "./Pages/UserManagement.jsx";
import AttendanceReports from "./Attendance/AttendanceReports.jsx";
import BusSchedule from "./Attendance/BusSchedule.jsx";
import BusTable from "./Attendance/BusTable.jsx";
import ManageBus from "./Attendance/ManageBus.jsx";
import TrackStudent from "./Attendance/TrackStudent.jsx";
import CreateClass from "./ClassSection/CreateClass.jsx";
import CreateSection from "./ClassSection/CreateSection.jsx";
import ManageTimetable from "./ClassSection/ManageTimetable.jsx";
import UpdateClass from "./ClassSection/UpdateClass.jsx";
import UpdateSection from "./ClassSection/UpdateSection.jsx";
import ExamResults from "./Examination/ExamResult.jsx";
import ExamDateSheet from "./Examination/ExamDateSheet.jsx";
import FeeCollection from "./Fees/FeeCollection.jsx";
import FeeReceipt from "./Fees/FeeReceipt.jsx";
import FeeStructure from "./Fees/FeeStructure.jsx";
import AddNotification from "./Notification/AddNotification.jsx";
import NewStudent from "./Student/NewStudent.jsx";
import StudentAttendance from "./Student/StudentAttendance.jsx";
import StudentTable from "./Student/StudentTable.jsx";
import ManageSubject from "./Subject/ManageSubject.jsx";
import SubjectTable from "./Subject/SubjectTable.jsx";
import NewRoles from "./User/NewRoles.jsx";
import Permissions from "./User/Permissions.jsx";
import ResetPassword from "./User/ResetPassword.jsx";
import TeachingStaff from "./Salary/TeachingStaff.jsx";
import NonTeachingStaff from "./Salary/NonTeachingStaff.jsx";
import ClassOverview from "./ClassSection/ClassOverview.jsx";
import AddAttendance from "./Student/AddAttendance.jsx";
import ViewAttendance from "./Student/ViewAttendance.jsx";
import LedgersStaff from "./Salary/LedgersStaff.jsx";
import StudentProfile from "./Student/StudentProfile.jsx";

import Hiring from "./Pages/Hiring.jsx";
import FeesList from "./Fees/FeesList.jsx";
import FeeReceiptDetails from "./Fees/FeeReciptDetails.jsx";
import FeeHeadPage from "./Fees/FeeHeadPage.jsx";
import TestSchedule from "./Examination/TestSchedule.jsx";
import ViewDateSheet from "./Examination/ViewDateSheet.jsx";
import BusRoutePage from "./Attendance/BusRoutePage.jsx";
import RouteLocation from "./Attendance/RouteLocation.jsx";
import StudentLedgers from "./Fees/StudentLedgers.jsx";
import StudentLedger from "./Fees/StudentLedger.jsx";
import FeeStructurePage from "./Fees/FeeStructurePage.jsx";
import ViewTimetable from "./ClassSection/ViewTimetable.jsx";
import ViewTeacher from "./Teacher/ViewTeacher.jsx";
import AddDesignation from "./NonTeaching/AddDesignation.jsx";
import StaffEnrollment from "./NonTeaching/StaffEnrollment.jsx";
import StaffAttendance from "./NonTeaching/StaffAttendance.jsx";
import SchoolTiming from "./ClassSection/SchoolTiming.jsx";
import Homework from "./Homwork/Homework.jsx";
import CreateOpening from "./Hire/CreateOpening.jsx";
import CurrentOpenings from "./Hire/CurrentOpenings.jsx";
import ViewNonTeachingList from "./NonTeaching/ViewNonTeachingList.jsx";
import Login from "./Pages/Login.jsx";
import Events from "./Notification/Events.jsx";
import HomeworkManagement from "./Pages/HomeworkManagement.jsx";
import Assignment from "./Homwork/Assignment.jsx";
import CourseMaterial from "./Homwork/CourseMaterial.jsx";
import OldPaper from "./Examination/OldPaper.jsx";
import StudentDeactivate from "./Student/StudentDeactivate.jsx";
import TodayThought from "./Notification/TodayThought.jsx";
import StudentAchievement from "./Notification/StudentAchievement.jsx";
import SchoolAchievement from "./Notification/SchoolAchievement.jsx";
import Schooldata from "./User/Schooldata.jsx";
import ClassTopperPage from "./Examination/ClassTopperPage.jsx";
import ReportsManagement from "./Pages/ReportsManagement.jsx";
import PromotionManagement from "./Pages/PromotionManagement.jsx";
import AddSession from "./Promotion/AddSession.jsx";
import PromoteSession from "./Promotion/PromoteSession.jsx";
import CertificateManagement from "./Pages/CertificateManagement.jsx";
import SchoolLeavingCertificates from "./Certificates/SchoolLeavingCertificates.jsx";
import DobCertificates from "./Certificates/DobCertificates.jsx";
import CharcterCerticates from "./Certificates/CharcterCerticates.jsx";
import FamilyIncomeCertificates from "./Certificates/FamilyIncomeCertificates.jsx";
import FeeReportsManagement from "./Reports/FeeReportsManagement.jsx";
import StaffReport from "./Reports/StaffReport.jsx";
import TransportationReport from "./Reports/TransportationReport.jsx";
import StudentReport from "./Reports/StudentReport.jsx";
import AllocateStudent from "./Attendance/AllocateStudent.jsx";
import ViewStaffLedger from "./Salary/ViewStaffLedger.jsx";
import AdvanceStaff from "./Salary/AdvanceStaff.jsx";
import AddNotificationClasswise from "./Notification/AddNotificationClasswise.jsx";
import ParentsForm from "./Student/ParentsForm.jsx";
import ViewParent from "./Student/ViewParent.jsx";
import EnrollGuardian from "./Student/EnrollGuardian.jsx";
import ViewGuardian from "./Student/ViewGuardian.jsx";
import Gatepass from "./Student/Gatepass.jsx";
import ViewGatepass from "./Student/ViewGatepass.jsx";
import BulkStudentUpload from "./Student/BulkCreate.jsx";
import CreateExam from "./Pages/CreateExam";
import GiveSalary from "./Salary/GiveSalary.jsx";
import ConcessionHeadPage from "./Fees/ConcessionHead.jsx";
import BulkTeacherUpload from "./Teacher/BulkTeacherupload.jsx";
import ViewProfile from "./Pages/Profile.jsx"
import Dashboard from "./Pages/Dashboard.jsx";
import Gallery from "./Pages/gallery.jsx";
import SiblingReport from "./Reports/SiblingReport.jsx";
import FeeReportsByClass from "./Reports/FeeReportsByClass.jsx";
import StudentTransportationReport from "./Reports/StudentTransportationReport.jsx";
import CustomFeeReport from "./Reports/CustomFeeReport.jsx";
import FeeRegister from "./Reports/FeeRegister.jsx";
import FeeSummaryPage from "./Reports/FeeSummary.jsx";
import StudentFeeStructure from "./Fees/StudentFeeStructure.jsx";
import InchargeReports from "./Reports/InchargeReports.jsx";


const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
    setLoading(false);
  }, []);

  useEffect(() => {
    const handler = () => {
      const token = localStorage.getItem("token");
      setIsAuthenticated(!!token);
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);


  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  // If loading, show a loading spinner or return nothing
  if (loading) {
    return <div>Loading...</div>; // Add a spinner here if needed
  }

  // Redirect if not authenticated and trying to access non-login pages
  if (!isAuthenticated && !isLoginPage) {
    return <Navigate to="/login" />;
  }

  // Redirect authenticated users from login page to home or dashboard
  if (isAuthenticated && isLoginPage) {
    return <Navigate to="/" />;
  }


  return (
    <div className="layout ">
      {/* Conditionally render Navbar and Sidebar if not on the Login page */}
      {!isLoginPage && <Navbar toggleSidebar={toggleSidebar} />}
      <div className="content w-full">
        {!isLoginPage && <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />}
        <div className="main-content">
          <Routes>
            {/* Login route */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/view-profile" element={<ViewProfile />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/create-exam" element={<CreateExam />} />
            <Route
              path="/attendance-management"
              element={<AttendanceManagement />}
            />
            <Route path="/class-management" element={<ClassManagement />} />
            <Route path="/examination" element={<Examination />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="/fee-management" element={<FeeManagement />} />
            <Route
              path="/notification-management"
              element={<NotificationManagement />}
            />
            <Route path="/salary-management" element={<SalaryManagement />} />
            <Route path="/student-management" element={<StudentManagement />} />
            <Route path="/subject-management" element={<SubjectManagement />} />
            <Route path="/teacher-management" element={<TeacherManagement />} />
            <Route
              path="/transportation-management"
              element={<TransportationManagement />}
            />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/report-management" element={<ReportsManagement />} />
            <Route path="/promote-student" element={<PromotionManagement />} />
            {/* attendance routing */}
            <Route path="/attendance-reports" element={<AttendanceReports />} />
            <Route path="/bus-schedule" element={<BusSchedule />} />
            <Route path="/bus-routes" element={<BusRoutePage />} />
            <Route path="/bus-location" element={<RouteLocation />} />
            <Route path="/bus-table" element={<BusTable />} />
            <Route path="/manage-bus" element={<ManageBus />} />
            <Route path="/allocate-student" element={<AllocateStudent />} />
            <Route path="/track-student" element={<TrackStudent />} />
            {/* classsection routing */}

            <Route path="/classes/:classId" element={<ClassOverview />} />
            <Route path="/create-class" element={<CreateClass />} />
            <Route path="/create-section" element={<CreateSection />} />
            <Route path="/school-timing" element={<SchoolTiming />} />
            <Route path="/manage-timetable" element={<ManageTimetable />} />
            <Route path="/viewTimetable/:id" element={<ViewTimetable />} />
            <Route path="/update-class" element={<UpdateClass />} />
            <Route path="/update-section" element={<UpdateSection />} />
            {/* Homework and assignments routing */}
            <Route path="/class-homework" element={<Homework />} />
            <Route path="/class-assignments" element={<Assignment />} />
            <Route path="/course-material" element={<CourseMaterial />} />
            {/* Hire section routing */}
            <Route path="/createOpening" element={<CreateOpening />} />
            <Route path="/viewOpenings" element={<CurrentOpenings />} />
            {/* examination section routing */}
            <Route path="/exam-results" element={<ExamResults />} />
            <Route path="/exam-datesheet" element={<ExamDateSheet />} />
            <Route path="/view-datesheet/:id" element={<ViewDateSheet />} />
            <Route path="/test-schedule" element={<TestSchedule />} />
            <Route path="/old-papers" element={<OldPaper />} />
            <Route path="/class-toppers" element={<ClassTopperPage />} />
            {/* fees section routing */}
            <Route path="/fee-collection" element={<FeeCollection />} />
            <Route path="/fee-receipt" element={<FeeReceipt />} />
            <Route path="/student-ledgers" element={<StudentLedgers />} />
            <Route path="/ledger/:id" element={<StudentLedger />} />
            <Route
              path="/fee-receipt-details/:receiptId"
              element={<FeeReceiptDetails />}
            />
            <Route path="/fee-list" element={<FeesList />} />
            <Route
              path="/fee-structure/details/${finalFeeStructureId}"
              element={<FeeStructurePage />}
            />
            <Route path="/fee-heads" element={<FeeHeadPage />} />
            <Route path="/fee-structure/:classId" element={<FeeStructure />} />
            <Route path="/concession-heads" element={<ConcessionHeadPage />} />
            {/* notification section routing */}
            <Route path="/add-notification" element={<AddNotification />} />
            <Route path="/add-classwise-notification" element={<AddNotificationClasswise />} />
            <Route path="/add-events" element={<Events />} />
            <Route path="/todays-thought" element={<TodayThought />} />
            <Route
              path="/student-achievement"
              element={<StudentAchievement />}
            />
            <Route path="/school-achievement" element={<SchoolAchievement />} />
            {/* Salary section */}
            <Route path="/teacher-salary" element={<TeachingStaff />} />
            <Route path="/non-teaching-salary" element={<NonTeachingStaff />} />
            {/* student section routing */}
            <Route path="/parents-form" element={<ParentsForm />} />
            <Route path="/view-parent/:id" element={<ViewParent />} />
            <Route path="/new-student" element={<NewStudent />} />
            <Route path="/enroll-guardian" element={<EnrollGuardian />} />
            <Route path="/view-guardian/:id" element={<ViewGuardian />} />
            <Route path="/gatepass-management" element={<Gatepass />} />
            <Route path="/view-gatepass/:id" element={<ViewGatepass />} />
            <Route path="/student-attendance" element={<StudentAttendance />} />
            <Route path="/student-table" element={<StudentTable />} />
            <Route path="/add-attendance" element={<AddAttendance />} />
            <Route path="/view-attendance" element={<ViewAttendance />} />
            <Route path="/students/:id" element={<StudentProfile />} />
            <Route
              path="/Deactivate/:studentId"
              element={<StudentDeactivate />}
            />
            <Route
              path="/homework-assignments"
              element={<HomeworkManagement />}
            />
            <Route
              path="/bulk-upload"
              element={<BulkStudentUpload />}
            />

            <Route
              path="/student-certificates"
              element={<CertificateManagement />}
            />
            {/* Certificates Management */}
            <Route
              path="/school-leaving-certificate"
              element={<SchoolLeavingCertificates />}
            />
            <Route path="/dob-certificate" element={<DobCertificates />} />
            <Route
              path="/character-certificate"
              element={<CharcterCerticates />}
            />
            <Route
              path="/family-income-certificate"
              element={<FamilyIncomeCertificates />}
            />
            {/* subject section routing */}
            <Route path="/manage-subject" element={<ManageSubject />} />
            <Route path="/Subject-Table" element={<SubjectTable />} />
            {/* teacher section routing */}
            <Route path="/teacher-enrollment" element={<StaffEnrollment />} />
            <Route path="/staff-attendance" element={<StaffAttendance />} />
            <Route
              path="/nonTeachingStaff/:id"
              element={<ViewNonTeachingList />}
            />
            <Route path="/teachers/:id" element={<ViewTeacher />} />
            <Route path="/add-designation" element={<AddDesignation />} />
            <Route path="/bulk-teacher-upload" element={<BulkTeacherUpload />} />
            {/* user section routing */}
            <Route path="/new-roles" element={<NewRoles />} />
            <Route path="/permissions" element={<Permissions />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/school-data" element={<Schooldata />} />
            <Route path="/topper" element={<ClassTopperPage />} />
            <Route path="/bulk" element={<BulkStudentUpload />} />
            {/* reports section routing */}
            {/* Fee Report Routes */}
            <Route path="/fee-report" element={<FeeReportsManagement />} />
            <Route path="/fee-report/by-class" element={<FeeReportsByClass />} />
            <Route path="/fee-report/custom" element={<CustomFeeReport />} />
            <Route path="/fee-report/by-cash" element={<FeeReportsManagement />} />
             <Route path="/fee-report/monthly-register" element={<FeeRegister />} />
              <Route path="/fee-report/summarize" element={<FeeSummaryPage />} />
            
            {/* <Route path="/student-report" element={<StudentReport />} /> */}
            <Route path="/student-report/details" element={<StudentReport />} />
        
            <Route path="/student-report/sibling" element={<SiblingReport />} />
            <Route path="/staff-report/details" element={<StaffReport />} />

            <Route path="/transportation-report/routes" element={<TransportationReport />} />
            <Route path="/transportation-report/vehicles" element={<StudentTransportationReport />} />

            {/* promotion section routing */}
            <Route path="/add-session" element={<AddSession />} />
            <Route path="/promote-session" element={<PromoteSession />} />
            {/* ledger staff */}
            <Route path="/ledgerStaff" element={<LedgersStaff />} />
            <Route path="/ledgerStaffId/:id" element={<ViewStaffLedger />} />
            <Route path="/advance-staff/:staffId" element={<AdvanceStaff />} />
            <Route path="/give-salary" element={<GiveSalary />} />
            <Route path="/gallery" element={<Gallery />} />
<Route
  path="/students/:studentId/fee-structure"
  element={<StudentFeeStructure />}
/>
<Route
  path="/staff-report/incharge-report"
  element={<InchargeReports />}
/>

            {/* If authenticated and valid routes exist */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
      {/* Conditionally render Footer if not on the Login page */}
      {!isLoginPage && <Footer />}
    </div>
  );
};

export default Layout;